import React, { useState } from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { Dialog, Button, Image } from "hesus-ui-kit";
import { useSelector } from "react-redux";
import DocumentPreview from "../../Document/DocumentPreview/DocumentPreview";

import Country from "../ProductsList/components/Country/Country";
import GeneralInfo from "../ProductsList/components/GeneralInfo/GeneralInfo";
import dotIcon from "@icons/ic-dot-navy-blue.svg";
import {
  AnalyticalWrapper,
  DocumentRow,
  DocumentInfo,
  DocumentWrppaer,
  AnalyticalTitleText,
  DocumentName,
} from "../../AnalyticalNotes/AnalyticalNoteView/AnalyticalNoteView.styled";
import "../../AnalyticalNotes/AnalyticalNoteView/AnalyticalNoteView.scss";
import {
  HeaderWrapper,
  ButtonWrapper,
  FormBody,
  Title,
  OptionsWrapper,
  FlexRow,
  SectionContainer,
  OuterWrapper,
  RowTitleText,
  WrapperStatus,
  ContactDetail,
  CompanyDetail,
  ActiveButton,
  InActiveButton,
  ChildDiv,
} from "./ProductView.styled";

import closeIcon from "@icons/ic-close-white.svg";

const ProductView = (props) => {
  const { t, id, title, onClose, onEdit } = props;
  const productInfo = useSelector((state) => state.productsList.byId[id]);
  const [selectedDocument, setSelectedDocument] = useState(null);

  const openPreview = (document) => setSelectedDocument(document);
  const closePreview = () => setSelectedDocument(null);
  const countryInfo = {
    countryInfo: productInfo.country,
    status: productInfo.isActive,
  };

  const operationData = {
    canDelivery: productInfo.canDelivery,
    canEvacuate: productInfo.canEvacuate,
    canEdit: productInfo.canEdit,
    status: productInfo.isActive,
  };

  const productCode = {
    name: !productInfo.productCode ? "-" : productInfo.productCode,
  };
  return (
    <>
      <Dialog width="45rem">
        <div>
          <HeaderWrapper>
            <Title>{title}</Title>
            <Button
              onClick={onClose}
              styles={{
                backgroundColor: "transparent",
                border: "none",
                height: "auto",
                padding: 0,
                "&:hover": {
                  backgroundColor: "transparent",
                },
              }}
            >
              <Image src={closeIcon} alt="close popup" />
            </Button>
          </HeaderWrapper>
          <FormBody>
            <OptionsWrapper>
              <FlexRow>
                <SectionContainer>
                  <OuterWrapper>
                    <ContactDetail>
                      <RowTitleText>
                        {productInfo.name !== null && productInfo.name}
                      </RowTitleText>
                      <CompanyDetail>
                        {productInfo?.category?.name !== null &&
                          t(productInfo?.category?.name) + " "}
                        {productInfo?.subCategory?.name !== null &&
                          "- " + t(productInfo?.subCategory?.name) + " "}
                      </CompanyDetail>
                    </ContactDetail>
                    <WrapperStatus>
                      <ChildDiv>
                        <Country page="view" data={countryInfo} />
                      </ChildDiv>
                      {productInfo?.isActive == 1 && (
                        <ChildDiv>
                          <ActiveButton>{t("ACTIVE")}</ActiveButton>
                        </ChildDiv>
                      )}
                      {productInfo?.isActive == 0 && (
                        <ChildDiv>
                          <InActiveButton>{t("INACTIVE")}</InActiveButton>
                        </ChildDiv>
                      )}
                    </WrapperStatus>
                  </OuterWrapper>
                  {operationData && (
                    <OuterWrapper>
                      <DocumentWrppaer>
                        <AnalyticalWrapper>
                          <AnalyticalTitleText>
                            {t("OPERATIONS")}
                          </AnalyticalTitleText>
                        </AnalyticalWrapper>
                        <DocumentRow>
                          <GeneralInfo
                            data={operationData}
                            column="operation"
                            page="view"
                          />
                        </DocumentRow>
                      </DocumentWrppaer>
                      <DocumentWrppaer>
                        <AnalyticalWrapper>
                          <AnalyticalTitleText>
                            {t("PRODUCT_CODE")}
                          </AnalyticalTitleText>
                        </AnalyticalWrapper>
                        <DocumentRow>
                          <GeneralInfo
                            data={productCode}
                            column="productCode"
                            page="view"
                          />
                        </DocumentRow>
                      </DocumentWrppaer>
                    </OuterWrapper>
                  )}

                  {productInfo.documents.length > 0 && (
                    <DocumentWrppaer>
                      <AnalyticalWrapper>
                        <AnalyticalTitleText>
                          {t("DOCUMENTS")}
                        </AnalyticalTitleText>
                      </AnalyticalWrapper>
                      {productInfo.documents.map((document) => {
                        return (
                          <DocumentRow key={document.id}>
                            <DocumentInfo>
                              <DocumentName
                                onClick={() => openPreview(document)}
                                className="analytical-notes-view__download-link"
                              >
                                <Image
                                  className="deleteImage"
                                  src={dotIcon}
                                  alt="delete"
                                  styles={{ width: "auto", marginRight: "6px" }}
                                />
                                {document.fileName}
                              </DocumentName>
                            </DocumentInfo>
                          </DocumentRow>
                        );
                      })}
                    </DocumentWrppaer>
                  )}
                </SectionContainer>
              </FlexRow>
            </OptionsWrapper>
            <ButtonWrapper>
              <Button
                styles={{
                  color: "#333",
                  background: "#fff",
                  border: "1px solid #ccc",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#ccc",
                  },
                }}
                onClick={onClose}
              >
                <>{t("CLOSE")}</>
              </Button>
              <Button
                styles={{
                  color: "white",
                  background: "#1BACE4",
                  border: "1px solid #1BACE4",
                  marginRight: "0.32rem",
                  "&:hover": {
                    backgroundColor: "#1589b6",
                  },
                }}
                onClick={onEdit}
              >
                {t("EDIT")}
              </Button>
            </ButtonWrapper>
          </FormBody>
        </div>
      </Dialog>
      {selectedDocument && (
        <DocumentPreview document={selectedDocument} onClose={closePreview} />
      )}
    </>
  );
};

ProductView.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslation()(ProductView);
